import { DeviceTypeConfigurations, type FirstPartyDeviceType, type ThirdPartyDeviceType } from "verdi-common";

/**
 * Map of device type to configuration key
 *
 * Some device types (model.type) do NOT match the configuration key of their configuration and
 * need this mapping to get the correct configuration key
 */
export const deviceTypeToConfigurationKey: Record<string, FirstPartyDeviceType | ThirdPartyDeviceType> = {
    msense: "sensoterraProbe",
};

/**
 * Get the configuration for a device
 */
export function getDeviceConfiguration(deviceType: FirstPartyDeviceType | ThirdPartyDeviceType) {
    // Convert device type to configuration key if needed
    const configurationKey = deviceTypeToConfigurationKey[deviceType] ?? deviceType;

    return DeviceTypeConfigurations[configurationKey] ?? undefined;
}

/**
 * Returns true if the device type is a third-party gateway (isGateway: true in its config).
 */
export function isThirdPartyGateway(deviceType: string): boolean {
    const config = DeviceTypeConfigurations[deviceType as ThirdPartyDeviceType];
    return config?.isVerdiDevice === false && config.isGateway === true;
}
